import { render, staticRenderFns } from "./ManageFonts.vue?vue&type=template&id=7c6708d7&scoped=true&"
import script from "./ManageFonts.vue?vue&type=script&lang=js&"
export * from "./ManageFonts.vue?vue&type=script&lang=js&"
import style0 from "./ManageFonts.vue?vue&type=style&index=0&id=7c6708d7&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c6708d7",
  null
  
)

export default component.exports